import { useTranslation } from 'react-i18next'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../../constants/common'
import { NEWSBOARD_STATUS } from '../../../../../constants/newsboard'
import { useDateLocale, useTimeZone } from '../../../../../hooks'
import { formatDateRelativeToToday } from '../../../../../utils/date'
import { getUserListItemContentText } from '../../../../../utils/user'
import { ActionSelect } from '../../../../Action'
import { Avatar, AVATAR_HEIGHT_32 } from '../../../../Avatar'
import { Divider, DIVIDER_STYLE } from '../../../../Divider'
import { Status } from '../../../../Status'
import Text from '../../../../Text'

import * as styles from './RequestProfileTabRatingCardHeader.module.css'

function RequestProfileTabRatingCardHeader({
  actions = EMPTY_LIST,
  created,
  owner = EMPTY_OBJECT,
  status,
  onClickAction,
}) {
  const { t } = useTranslation()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  const name = getUserListItemContentText({
    companyPostName: owner.company_post_name,
    fullname: owner.fullname,
    role: owner.role,
  })

  const dateCreated = created
    ? formatDateRelativeToToday(created, locale, timezone)
    : null

  const statusConfig = status ? NEWSBOARD_STATUS[status] : null

  return (
    <div className={styles.header}>
      <Avatar
        color={owner.avatar_color}
        size={AVATAR_HEIGHT_32}
        src={owner.avatar}
        text={owner.fullname}
      />
      <div className={styles.info}>
        <Text className={styles.name}>{name}</Text>
        {statusConfig || dateCreated ? (
          <div className={styles.meta}>
            {statusConfig ? (
              <Status
                text={t(statusConfig.text)}
                textColor={statusConfig.textColor}
              />
            ) : null}
            {statusConfig && dateCreated ? (
              <Divider style={DIVIDER_STYLE.Round} />
            ) : null}
            {dateCreated ? <Text isSecondary>{dateCreated}</Text> : null}
          </div>
        ) : null}
      </div>
      {actions.length > 0 ? (
        <ActionSelect actions={actions} onClickAction={onClickAction} />
      ) : null}
    </div>
  )
}

export default RequestProfileTabRatingCardHeader
